import { Injectable } from '@angular/core';

declare let gtag: Function;

@Injectable({
  providedIn: 'root',
})
export class GoogleAnalyticsService {
  constructor() {}

  public eventEmitter(
    eventName: string,
    eventCategory: string,
    eventLabel: string,
    eventValue: number
  ) {
    gtag('event', eventName, {
      event_category: eventCategory,
      event_label: eventLabel,
      value: eventValue,
    });
  }

  public convertEventEmitter() {
    gtag('event', 'conversion', {
      send_to: 'AW-397434627/rv6KCIyugYYDEIO-wb0B',
      transaction_id: '',
    });
  }
}
